export default "__VITE_ASSET__60b7996f__"